/**
 * DevExtreme (esm/__internal/pagination/common/consts.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const PAGER_CLASS = "dx-pager";
export const PAGINATION_CLASS = "dx-pagination";
export const LIGHT_MODE_CLASS = "dx-light-mode";
export const PAGINATION_PAGES_CLASS = "dx-pages";
export const PAGINATION_PAGE_INDEXES_CLASS = "dx-page-indexes";
export const PAGINATION_PAGE_CLASS = "dx-page";
export const PAGINATION_SELECTION_CLASS = "dx-selection";
export const PAGINATION_PAGE_SIZE_CLASS = "dx-page-size";
export const PAGINATION_PAGE_SIZES_CLASS = "dx-page-sizes";
export const PAGINATION_SELECTED_PAGE_SIZE_CLASS = "dx-page-size dx-selection";
export const FIRST_CHILD_CLASS = "dx-first-child";